module.exports = new __parcel__URL__("troops_ars_small_v2.d710f1a6.png").toString();